export const sortSite = (siteName: string) => {
	switch (siteName) {
		case "Property Station (hket)":
			return "hket"
		default:
			return siteName
	}
}
